(async () => {
  if (!customElements.get("slider-rao")) {
    const {
      default: Swiper,
      Navigation: Navigation,
      Pagination: Pagination,
      EffectFade: EffectFade
    } = await import("./swiper.esm-8fb044b1.async.js");

    class SliderRAO extends HTMLElement {
      constructor() {
        super();

        this.autoplayMobile = this.getAttribute('data-autoplay-mobile') === 'true';
        this.imageSwiperElement = this.querySelector(".image-carousel");
        this.imageSwiperOptions = {
          slidesPerView: 1.5,
          loopAdditionalSlides: 10,
          centeredSlides: true,
          centeredSlidesBounds: true,
          loop: true,
          autoplay: false,
          direction: "horizontal",
          spaceBetween: 0,
          breakpoints: {
            768: {
              slidesPerView: 4
            },
            1680: {
              slidesPerView: 4
            }
          },
          navigation: this.querySelector('.swiper-button-next, .swiper-button-prev') !== null ? {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
          } : false,
          pagination: this.querySelector('.swiper-pagination') !== null ? {
            el: ".swiper-pagination",
            type: "bullets",
            clickable: true
          } : false,
          on: {
            touchEnd: function () {
              const indexChangeFn = () => {
                this.el.closest('slider-rao').dispatchEvent(new CustomEvent('imageChange', {
                  detail: {
                    index: this.realIndex
                  }
                }));
              };
              this.on('realIndexChange', () => {
                indexChangeFn();

                this.off('realIndexChange', indexChangeFn);
              });
            },
            afterInit: () => {
              window.requestAnimationFrame(() => {
                if (this.autoplayMobile === true) {
                  this.handleMobileAutoplay.call(this);
                }
              });
            }
          },
          modules: [Navigation, Pagination, EffectFade]
        };

        this.init();
      }

      init() {
        Shopify.designMode && this.swiperElement && window.addEventListener("shopify:section:load", (() => {
          this.imageSwiperInstance.update();
        }));

        this.imageSwiperInstance = new Swiper(this.imageSwiperElement, this.imageSwiperOptions);

        const playPauseBtns = this.querySelectorAll('.play-button');

        playPauseBtns.forEach(ppb => {
          const video = ppb.parentElement.querySelector('video');
          const playIcon = ppb.querySelector('.playIcon');
          const pauseIcon = ppb.querySelector('.pauseIcon');

          video.addEventListener('play', () => {
              ppb.parentElement.classList.remove('paused');
              ppb.parentElement.classList.add('playing');
              playIcon.style.display = 'none';
              pauseIcon.style.display = 'flex';
          });

          video.addEventListener('pause', () => {
              ppb.parentElement.classList.remove('playing');
              ppb.parentElement.classList.add('paused');
              playIcon.style.display = 'flex';
              pauseIcon.style.display = 'none';
          });

          ppb.addEventListener('click', () => {
            if (window.innerWidth <= 767) {
              this.togglePlayPause(video);
            }
          });

          ppb.parentElement.addEventListener('mouseover', () => {
            if (window.innerWidth > 768) {
              this.togglePlay(video);
            }
          });

          ppb.parentElement.addEventListener('mouseout', () => {
            if (window.innerWidth > 768) {
              this.togglePause(video);
            }
          });
        });

        if (this.autoplayMobile === true) {
          this.addEventListener('imageChange', () => {
            this.handleMobileAutoplay();
          });
        }
      }

      handleMobileAutoplay() {
        const swiper = this.imageSwiperInstance;

        console.log(swiper);

        if (!swiper || !swiper.slides) {
          return;
        }

        const mq = window.matchMedia('(min-width: 768px)');
        const activeIndex = swiper.activeIndex;

        swiper.slides.forEach((slide, index) => {
          const video = slide.querySelector('video');
          if (!video) return;

          if (index === activeIndex) {
            if (!mq.matches) {
              video.play().catch(() => {});
            } else {
              video.pause();
              video.currentTime = 0;
            }
          } else {
            video.pause();
            video.currentTime = 0;
          }
        });
      }

      togglePlayPause(el) {
        if (el.paused) {
          el.play();
        } else {
          el.pause();
        }
      }

      togglePlay(el) {
        el.play();
      }

      togglePause(el) {
        el.pause();
      }
    }

    window.SliderRAO = SliderRAO;
    customElements.define("slider-rao", SliderRAO);
  }
})();